import { render, staticRenderFns } from "./PlatformPaymentFormDialog.vue?vue&type=template&id=7dfed59a"
import script from "./PlatformPaymentFormDialog.vue?vue&type=script&lang=js"
export * from "./PlatformPaymentFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports